import axios from 'axios'
import { nextTick, type WritableComputedRef } from 'vue'
import { createI18n, type I18n } from 'vue-i18n'
import fallbackTranslationsEn from './fallbackTranslationsEn.json'

const initialLocale = 'en'

export const i18n = createI18n({ locale: initialLocale })

// Makes 'de-CH' to de. 'de' will stay 'de'
function normalizeLocale(locale: string) {
  if (locale.length > 2) {
    return locale.split('-')[0]
  }
  return locale
}

export function setI18nLanguage(i18n: I18n, locale = initialLocale) {
  const normalized = normalizeLocale(locale)
  if (i18n.mode === 'legacy') {
    i18n.global.locale = normalized
  } else {
    ;(i18n.global.locale as WritableComputedRef<string, string>).value =
      normalized
  }
}

export async function loadLocaleMessages(
  i18n: I18n,
  baseUrl: string,
  locale = initialLocale,
) {
  const normalized = normalizeLocale(locale)

  const axiosClient = axios.create({
    baseURL: __PROXY_HOST__?.host ?? baseUrl,
  })

  try {
    const { data } = await axiosClient.get(
      `/web/api/v2/translations/idp/${normalized === 'de' ? 'de-CH' : normalized}`,
    )
    i18n.global.setLocaleMessage(normalized, data)
  } catch {
    try {
      // Fall back to English
      const { data } = await axiosClient.get(`/web/api/v2/translations/idp/en`)
      i18n.global.setLocaleMessage(normalized, data)
    } catch {
      // Fall back to an unmaintained static export of the translations
      // This happens when the baseUrl is not obtained from the Keycloak server
      // (for example with a wrong or unknown client id) because the the baseUrl is set per client.
      i18n.global.setLocaleMessage(normalized, fallbackTranslationsEn)
    }
  }

  return nextTick()
}
